// angular
// .module("HeroPRO")
// .factory("UiDisplayFactory", uiDisplayFactory);

import _ from 'lodash';
/* @ngInject */


export default function uiDisplayFactory($rootScope, $state, HPGeoStates, HPDisplayRules, HPTopNavRules, HPSidebarRules, HPDashboardRules, PermissionsFactory) {
    const currentDisplayRules = {
        rulesLoaded: false,
    };

    let _blacklistStateName = '';

    return {
        getDisplayRules,
        setDisplayData,
        setDisplayRule,
        getBlacklistStateName,
    };
    /*= =======================================
     =            Public Functions            =
     ======================================== */

    // TODO: Add private method to retrieve and store DisplayData. setDisplayData is temporary for calculations.
    function setDisplayData(data) {
        let accessLevel;
        // TODO: Re-write logic here to calculate currentDisplayRules from claims.

        if (data.ServiceStateDetails !== undefined && data.ServiceStateDetails !== null && data.ServiceStateDetails.length > 0) {
            accessLevel = getAccessLevel(data.ServiceStateDetails);
        } else {
            accessLevel = 'whitelist';
        }

        switch (accessLevel) {
        case _.keys(HPGeoStates)[0]: // whitelist rules

            getTopNavRules(currentDisplayRules);
            getSidebarRules(currentDisplayRules);
            getDashboardRules(currentDisplayRules);

            // TODO: Update with better way to find specific states
            var caServiceLocation = _.find(data.ServiceStateDetails, svcState => svcState.StateGeoId === HPGeoStates.whitelist.California);

            _.extend(currentDisplayRules, HPDisplayRules[_.keys(HPGeoStates)[0]]);

            // Condition to display CSLB under Account Info for CA Service Locations.
            if (caServiceLocation) {
                currentDisplayRules.showCSLB = true;
            } else {
                currentDisplayRules.showCSLB = false;
            }

            break;
        case '': // blacklist rules
        case _.keys(HPGeoStates)[1]: // blacklist rules
            setBlacklistStateName(data.ServiceStateDetails[0]);

            // Set rule to configure TopNav and Sidebar to use reduced Benji Contractor view
            setDisplayRule('benjiView', true);

            getTopNavRules(currentDisplayRules);
            getSidebarRules(currentDisplayRules);
            getDashboardRules(currentDisplayRules);

            _.extend(currentDisplayRules, HPDisplayRules[_.keys(HPGeoStates)[1]]);

            break;
        }

        currentDisplayRules.rulesLoaded = true;
        // TODO: Remove payload if the rules processing can be performed synchronously.
        $rootScope.$broadcast('UpdateDisplay');
    }

    function setDisplayRule(propertyName, flag) {
        currentDisplayRules[propertyName] = flag;
    }

    function getDisplayRules() {
        return currentDisplayRules;
    }

    function getBlacklistStateName() {
        return _blacklistStateName;
    }

    /* -----  End of Public Functions  ------*/

    /*= =======================================
 =            Private Functions            =
 ======================================== */

    function getAccessLevel(serviceStates) {
        let accessLevel = '';
        let accessLevelMatchFound = false;
        _.each(HPGeoStates, (states, key) => {
            let matchFound = false;
            if (accessLevelMatchFound === false) {
                angular.forEach(states, (stateCode) => {
                    if (matchFound === false) {
                        for (let i = 0; i < serviceStates.length; i++) {
                            if (serviceStates[i].StateGeoId === stateCode) {
                                matchFound = true;
                                accessLevelMatchFound = true;
                                accessLevel = key;
                                break;
                            }
                        }
                    }
                });
            }
        });
        return accessLevel;
    }

    function setBlacklistStateName(serviceState) {
        let matchFound = false;
        _.each(HPGeoStates.blacklist, (code, key) => {
            if (matchFound === false) {
                if (code === serviceState.StateGeoId) {
                    matchFound = true;
                    _blacklistStateName = key;
                }
            }
        });
    }

    function getDashboardRules(currentDisplayRules) {
        let topDashboardFound = false;
        let customRules = HPDashboardRules.standard;
        _.each(currentDisplayRules, (rule, displayKeys) => {
            if (topDashboardFound === false && rule === true) {
                const matchingRuleSet = _.find(HPDashboardRules, (value, ruleKey) => ruleKey === displayKeys);
                if (matchingRuleSet !== undefined && matchingRuleSet !== null) {
                    topDashboardFound = true;
                    customRules = matchingRuleSet;
                }
            }
        });
        _.extend(currentDisplayRules, customRules);
    }

    function getTopNavRules(currentDisplayRules) {
        let topNavRuleFound = false;
        let customRules = HPTopNavRules.standard;
        _.each(currentDisplayRules, (rule, displayKeys) => {
            if (topNavRuleFound === false && rule === true) {
                const matchingRuleSet = _.find(HPTopNavRules, (value, ruleKey) => ruleKey === displayKeys);
                if (matchingRuleSet !== undefined && matchingRuleSet !== null) {
                    topNavRuleFound = true;
                    customRules = matchingRuleSet;
                }
            }
        });
        _.extend(currentDisplayRules, customRules);
    }

    function getSidebarRules(currentDisplayRules) {
        let sidebarRuleFound = false;
        let customRules = HPSidebarRules.standard;
        if (!PermissionsFactory.hasPermission('IsSolicitor')) {
            customRules = HPSidebarRules.PACEParticipant;
        }
        _.each(currentDisplayRules, (rule, displayKeys) => {
            if (sidebarRuleFound === false && rule === true) {
                const matchingRuleSet = _.find(HPSidebarRules, (value, ruleKey) => ruleKey === displayKeys);
                if (matchingRuleSet !== undefined && matchingRuleSet !== null) {
                    sidebarRuleFound = true;
                    customRules = matchingRuleSet;
                }
            }
        });
        _.extend(currentDisplayRules, customRules);
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/common/dataFactories/uiDisplayFactory.js